import * as yup from 'yup';

export const syndicSchema = yup.object({
  syndicId: yup.string().uuid().required(),
  syndicName: yup.string().required(),
  logoUrl: yup.string().url().optional(),
});
